
  export default {
    computed: {
      isHomepage () {
        return this.$route.path === '/';
      }
    }
  };
